import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { MijnInterfaceCacheService } from '@ap/mijn-interface-cache';

import { BaseKlantDetails, KlantDetails } from './klantbeheer.model';

@Injectable({
    providedIn: 'root'
})
export class KlantbeheerResource {
    private readonly mijnCacheService: MijnInterfaceCacheService = inject(MijnInterfaceCacheService);

    public geefIngelogdeKlantDetails(noCache = false): Observable<KlantDetails> {
        const headers = this.getHttpHeaders(noCache);

        return this.mijnCacheService
            .getData<BaseKlantDetails>('/services/k8s-apic-klantbeheer/api', 'klanten/ingelogd', -1, undefined, headers)
            .pipe(
                map<BaseKlantDetails, KlantDetails>((klantDetails) => {
                    return {
                        combinedName: this.getCombinedName(klantDetails),
                        ...klantDetails
                    };
                })
            );
    }

    private getHttpHeaders(noCache: boolean): HttpHeaders {
        let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json').set('X-Api-Key', '{<MIJN-OMGEVING-API-KEY>}');

        if (noCache) {
            httpHeaders = httpHeaders.set('Cache-Control', 'no-cache');
        }

        return httpHeaders;
    }

    private getCombinedName(klantDetails: BaseKlantDetails): string {
        const combinedName: string[] = [];

        if (klantDetails.roepnaam) {
            combinedName.push(this.capitalizeName(klantDetails.roepnaam));
        } else {
            combinedName.push(klantDetails.voorletters);
        }

        if (klantDetails.tussenvoegsel) {
            combinedName.push(klantDetails.tussenvoegsel);
        }

        combinedName.push(klantDetails.naam);

        return combinedName.join(' ');
    }

    private capitalizeName(name: string): string {
        return name.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase());
    }
}
